import styled from '@emotion/native';
import type { ColorName } from '@emotion/react';
import {
  BORDER_WIDTH,
  type BorderWidth,
  SPACING,
  type Spacing,
} from 'design-system/theme';
import { View } from 'react-native';

interface DividerProps {
  orientation: 'horizontal' | 'vertical';
  color?: ColorName;
  width?: BorderWidth;
  spacing?: Spacing;
  flex?: number;
}

export const Divider = styled(View)<DividerProps>(
  ({
    width: thickness = 1,
    color = 'divider',
    orientation,
    theme,
    spacing = 'none',
    flex,
  }) => {
    const borderWidth = BORDER_WIDTH[thickness];
    const marginWidth = SPACING[spacing];
    const backgroundColor = theme.color[color];

    if (orientation === 'vertical') {
      return {
        width: borderWidth,
        marginLeft: marginWidth,
        marginRight: marginWidth,
        backgroundColor,
        alignSelf: 'stretch',
        flex,
      };
    }

    return {
      height: borderWidth,
      marginBottom: marginWidth,
      marginTop: marginWidth,
      backgroundColor,
      alignSelf: 'stretch',
      flex,
    };
  },
);
